import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAssessmentByIdAPIresponse } from "./services";
import useDataFetch from "../../hooks/useDataFetch";
import RenderData from "./partials/renderData";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";
import {
  updateTitle,
  updateJobDesignation,
  updateExperience,
  resetStepOne,
} from "../../store/steps/stepOneSlice";
import { resetStepFour } from "../../store/steps/stepFourSlice";
import { resetStepFive } from "../../store/steps/stepFiveSlice";

const Create = () => {
  const { assessmentId } = useParams();
  const { data, loading, error } = useDataFetch(getAssessmentByIdAPIresponse, {
    req: assessmentId,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      dispatch(updateTitle(data.name));
      dispatch(updateJobDesignation(data.jobRole));
      dispatch(
        updateExperience([
          data.yearsOfExperience.min,
          data.yearsOfExperience.max,
        ])
      );
    }
  }, [data, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetStepOne());
      dispatch(resetStepFour());
      dispatch(resetStepFive());
    };
  }, []);

  if (error) {
    return <RenderError />;
  }

  if (loading) {
    return <RenderLoading />;
  }

  return <RenderData />;
};
export default Create;
